import { render } from "./LogoForms.vue?vue&type=template&id=5ee5c3c6&scoped=true"
const script = {}

import "./LogoForms.vue?vue&type=style&index=0&id=5ee5c3c6&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee5c3c6"]])

export default __exports__